<template>
  <div>

    <div class="text-h5 my-3 font-weight-bold">Mes participants à {{ mainStore.module.nom }}</div>

    <div v-if="has_commandes">
      <GlobalActionsCardCommande></GlobalActionsCardCommande>
      <LiensGroupeSection v-if="has_liens_groupe" :liens="list_liens_groupe"></LiensGroupeSection>
      <div class="text-h6 font-weight-bold">Mes commandes
        <v-chip class="ml-2" color="primary-dark" variant="flat" size="small">{{ list_commandes.length }}</v-chip>
      </div>
      <CommandeItem class="my-4" v-for="item in list_commandes" :item="item" :key="item.id"></CommandeItem>
    </div>
    <v-alert v-else-if="!has_commandes && register_by_other_user" class="my-3" border="start"
      border-color="red-darken-4" elevation="0">Vous n'avez pas d'inscription à cet évenement sur votre compte.
      Cependant, un autre utilisateur vous a inscrit sur son compte personnel. Veuillez vous rapprocher de cette
      personne pour éditer votre
      inscription.</v-alert>
    <v-alert v-else-if="!has_commandes && !register_by_other_user" class="my-3" border="start"
      border-color="red-darken-4" elevation="0">Vous n'avez pas
      encore inscrit de participant à cet évenement</v-alert>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import CommandeItem from "./Commande_Item.vue";
import GlobalActionsCardCommande from "./Global_Actions_Card_Commande.vue";
import LiensGroupeSection from "./Liens_Groupe_Section.vue";
import UserService from "@/services/user.service.js";

export default {
  components: {
    CommandeItem,
    GlobalActionsCardCommande,
    LiensGroupeSection,
  },
  data() {
    return {
      fiche_coureur: {},
      register_by_other_user: false,
    };
  },
  computed: {
    ...mapStores(useMainStore),
    list_commandes() {
      return this.fiche_coureur?.list || [];
    },
    has_commandes() {
      return this.list_commandes.length > 0;
    },
    list_liens_groupe() {
      const seen = new Set();
      return (this.fiche_coureur?.list || [])
        .map((c) => c.lien_groupe)
        .filter((lg) => lg?.token && !seen.has(lg.token) && seen.add(lg.token));
    },
    has_liens_groupe() {
      return this.list_liens_groupe.length > 0;
    },
  },
  async mounted() {
    this.fiche_coureur = await UserService.getFiche(this.mainStore.module.id);

    this.register_by_other_user = await UserService.getRegisterByOtherUser(this.mainStore.authUser.userData.mail, this.mainStore.module.id, this.mainStore.authUser.userData.id);


  },
};
</script>

<style lang="scss" scoped></style>